"use client";
import InputDataContent from "@/components/inquiryDetails/inputDataContent";
import { FlexCol } from "@/components/ui";

const SAMPLE = {
  nationalCode: "0012345678",
  customerType: "حقیقی",
  trackId: "TRK-1403052891",
};

const inputContent = [
  { label: "کد ملی", value: SAMPLE.nationalCode },
  { label: "نوع مشتری", value: SAMPLE.customerType },
  { label: "شناسه پیگیری", value: SAMPLE.trackId },
];

const BouncedCheckSample = () => {
  return (
    <FlexCol className="items-stretch">
      <div className="mb-5 flex items-center justify-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-2 text-xs text-amber-700">
        <span>⚠️</span>
        <span>این نتیجه صرفاً یک نمونه است و اطلاعات واقعی نیست</span>
      </div>

      <InputDataContent content={inputContent} />

      <h2 className="mb-4 text-center text-lg font-bold">نتیجه استعلام</h2>

      <div className="shadow-main mb-10 flex flex-col gap-6 rounded-xl p-4 py-8 sm:p-8">
        <p className="text-sm md:text-base">
          بر اساس بررسی‌های انجام‌شده،{" "}
          <span className="mx-1 font-semibold text-green-700">
            هیچ‌گونه سابقه‌ای از چک برگشتی
          </span>{" "}
          برای دارنده کد ملی مورد نظر در سامانه بانک مرکزی ثبت نشده است.
        </p>
      </div>
    </FlexCol>
  );
};

export default BouncedCheckSample;
